import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, finalize, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth-service/auth-service.service';
import { BaseNode } from '../../ui/Node/BaseNode';

@Injectable({
  providedIn: 'root'
})
export class MeddraService {

  private version!: number;
  private lastVersion!: number;
  public loading = new BehaviorSubject<boolean>(false);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService) { }

  getLastVersion(): number {
    return this.lastVersion;
  }

  resetVersion() {
    this.version = this.lastVersion;
  }

  getVersion(): number {
    return this.version;
  }

  setVersion(version: number) {
    this.version = version;
    if (!this.lastVersion){
      this.lastVersion = version;
    }
  }

  getAll(node: BaseNode, entity: string, criteria: string): Observable<{}> {
    return this.get(node, entity, criteria, 0, 2000, 2000, false);
  }

  filter(node: BaseNode, entity: string, criteria: string, pageNumber: number, or: boolean, filter:string): Observable<{}> {
    return this.get(node, entity, criteria, pageNumber, 50, 50, or);
  }

  get(node: BaseNode, entity: string, criteria: string, pageNumber: number, pageSize: number, fetchSize: number, or: boolean): Observable<{}> {

    this.loading.next(true);
    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });

    let params = new HttpParams().set('c', criteria);
    params = params.append('p', pageNumber);
    params = params.append('s', pageSize);
    params = params.append('f', fetchSize);
    params = params.append('or', or);

    return this.httpClient
      .get(`${environment.apiUrl}/api/meddra/search/${this.getVersion()}/${entity}`, {
        headers: headers, params: params
      })
      .pipe(
        map((resp) => {
          const result = resp as [];
          this.loading.next(false);
          return {node,result};
        })
      );
  }

  filterToExcel(entity: string, criteria: string, pageNumber: number, or: boolean, isExport: boolean, fields: any): Observable<HttpResponse<Blob>> {

    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });

    let params = new HttpParams().set('c', criteria);
    params = params.append('p', pageNumber);
    if (!isExport) {
      params = params.append('s', 0);
      params = params.append('f', 1000000);
    }
    params = params.append('or', or);
    params = params.append('fd', fields);

    return this.httpClient.get(`${environment.apiUrl}/api/meddra/search/excel/${this.getVersion()}/${entity}`, { headers: headers, params: params, responseType: 'blob', observe: 'response' });
  }

  exportResultsToExcel(entity: string,data: any, fieldsToRetrieve: string): Observable<HttpResponse<Blob>> {

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken()
    });

    const formData = new FormData();
    formData.append("data", new Blob(
      [ JSON.stringify(data) ],
      { type: "application/json" }
    ));
    formData.append("fields", new Blob(
      [ fieldsToRetrieve ],
      { type: "application/json" }
    ));
    return this.httpClient.post(`${environment.apiUrl}/api/meddra/export/excel/${entity}`, formData,{ headers: headers, responseType: 'blob', observe: 'response' });
  }

}
